import Text from '@components/Text/Text';
import { Box, IconButton, styled, Theme } from '@mui/material';
import { iconBoxColor } from './IconButton';

const getIconBackgroundColor = (
  theme: Theme,
  color: iconBoxColor,
  outline: boolean | undefined,
  filled: boolean | undefined
): string => {
  if (filled) {
    return theme.palette[color ?? 'primary'].main;
  } else if (outline) {
    return theme.palette.common.white;
  }
  return 'none';
};

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  flexDirection: 'column',
  '&.MuiButtonBase-root:hover': {
    backgroundColor: 'transparent',
  },
  '&.MuiButtonBase-root .MuiTouchRipple-child': {
    backgroundColor: theme.palette.grey[500],
  },
}));

export const StyledIconRoundBox = styled(Box)<{
  outline: boolean | undefined;
  filled: boolean | undefined;
  color: iconBoxColor;
}>(({ theme, outline, filled, color }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  backgroundColor: getIconBackgroundColor(theme, color, outline, filled),
  border: outline ? `1px solid` : 'none',
  borderColor: outline ? theme.palette[color ?? 'primary'].main : 'none',
}));

export const IconButtonText = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.divider,
}));
